import styled from "styled-components";
export const Tabs = styled.div`
  background: #fff;
`;

export const Tab = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  position: relative;
  color:inherit;
  font-size:inherit;
  font-family:inherit;
  font-weight:inherit;
  height:50px;
  padding:0 20px;

  margin-right: 8px;
  border: ${props => (props.active ? "2px solid red" : "")};
  background-color: ${props => (props.active ? "blue" : "red")};
  transition: background-color 0.5s ease-in-out;

  // :hover {
  //   background-color: white;
  // }

  :after{
    content: ${props => (props.active ? "''" : "")};
    background-color: var(--mainBg);
    display: block;
    position: absolute;
    left: 0;
    width: 100%;
    bottom: -4px;
    height: 4px;
  }
`;
export const Content = styled.div`
    ${props => (props.active ? "" : "display:none")};
    border: 2px solid var(--tabsetBorder);
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 0 4px 4px;
`;